import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row justify-center q-mt-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_wrap = _resolveComponent("message-wrap")!
  const _component_answer_button = _resolveComponent("answer-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_message_wrap, {
      isShowMessageTail: _ctx.isShowMessageTail,
      message: _ctx.message,
      avatar: _ctx.avatar
    }, null, 8, ["isShowMessageTail", "message", "avatar"]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message.buttons, (button, index) => {
        return (_openBlock(), _createBlock(_component_answer_button, {
          key: index,
          button: button,
          onClickButtonWithPayload: _ctx.addGeo,
          style: _normalizeStyle({ ..._ctx.CalculaterButtonWidth(button.width) })
        }, null, 8, ["button", "onClickButtonWithPayload", "style"]))
      }), 128))
    ], 512), [
      [_vShow, _ctx.isLastMessage]
    ])
  ]))
}